// seo.config.js — Central SEO metadata for all prerendered public routes.
// Edit titles, descriptions, OG tags here. Components import and use this
// via their metaInfo() method — no hardcoded strings in components.
//
// Rules:
//   - title:       ≤60 chars. Format: "Primary Keyword — Qualifier | EL Connect"
//   - description: ≤160 chars. Lead with user benefit; include a number if possible.
//   - canonical:   always the clean non-www HTTPS URL, no trailing slash.
//   - og:image:    1200×630px. Use the general brand image as default.
//   - Keywords field intentionally omitted — Google ignores it; it's noise.

const BASE_URL = 'https://elconnect.sg';
const DEFAULT_OG_IMAGE = 'https://elconnect-preprod.sgp1.cdn.digitaloceanspaces.com/v2/banner_image/elconnect_banner.jpg';

const SEO = {
  '/': {
    title: 'Singapore Part Time Jobs | On Demand Jobs & Gig | EL Connect',
    description: 'Find part time jobs in Singapore. Flexible, immediate & on demand jobs — F&B, cleaning, high pay jobs & more. Trusted by 1,000+ employers. Gig work available.',
    canonical: `${BASE_URL}/`,
    og: {
      title: 'Singapore Part Time Jobs | On Demand Jobs & Gig | EL Connect',
      description: 'Find part time jobs in Singapore. Flexible, immediate & on demand jobs — F&B, cleaning, high pay jobs & more. Trusted by 1,000+ employers. Gig work available.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/jobseeker': {
    title: 'Singapore Part Time Jobs | Connecting Jobs Empowering Future',
    description: 'Browse part time jobs in Singapore — Flexible and high paying on demand, short gig and full time jobs. Many vacancies available. Apply via the EL Connect app.',
    canonical: `${BASE_URL}/jobseeker`,
    og: {
      title: 'Singapore Part Time Jobs | Connecting Jobs Empowering Future',
      description: 'Browse part time jobs in Singapore — Flexible and high paying on demand, short gig and full time jobs. Many vacancies available. Apply via the EL Connect app.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/employer': {
    title: 'Connect to Workers & Hire Smarter, Grow Faster | EL Connect',
    description: 'Post a job and reach verified part time workers across Singapore within hours. On-demand staffing for F&B, cleaning, retail, logistics & more. Fulfil manpower.',
    canonical: `${BASE_URL}/employer`,
    og: {
      title: 'Connect to Workers & Hire Smarter, Grow Faster | EL Connect',
      description: 'Post a job and reach verified part time workers across Singapore within hours. On-demand staffing for F&B, cleaning, retail, logistics & more. Fulfil manpower.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/about-us': {
    title: 'About EL Connect — Singapore Job Platform | Our Story',
    description: 'EL Connect links Singapore jobseekers with employers for part time, temporary gig, and full-time work. Founded 2020, headquartered in Toa Payoh, MOM-registered.',
    canonical: `${BASE_URL}/about-us`,
    og: {
      title: 'About EL Connect — Singapore Job Platform | Our Story',
      description: 'EL Connect links Singapore jobseekers with employers for part time, temporary gig, and full-time work. Founded 2020, headquartered in Toa Payoh, MOM-registered.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/faq': {
    title: 'FAQ — EL Connect Help & Frequently Asked Questions',
    description: 'Get answers about applying for jobs, payouts, employer posting, account setup, and more on EL Connect — Singapore\'s part time and on demand staffing platform.',
    canonical: `${BASE_URL}/faq`,
    og: {
      title: 'FAQ — EL Connect Help & Frequently Asked Questions',
      description: 'Get answers about applying for jobs, payouts, employer posting, account setup, and more on EL Connect — Singapore\'s part time and on demand staffing platform.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/blog': {
    title: 'Blog — Singapore Work & Job Hiring Guides | EL Connect',
    description: 'Insightful guides on part time work, temporary staffing, Singapore job hunting tips & hiring advice. Stay informed with EL Connect\'s career & employer resources.',
    canonical: `${BASE_URL}/blog`,
    og: {
      title: 'Blog — Singapore Work & Job Hiring Guides | EL Connect',
      description: 'Insightful guides on part time work, temporary staffing, Singapore job hunting tips & hiring advice. Stay informed with EL Connect\'s career & employer resources.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/rewards': {
    title: 'Rewards & Deals for Jobseekers in Singapore | EL Connect',
    description: 'Earn ElCoins, unlock exclusive rewards, and join Lucky Draw promotions on EL Connect. The more you work, the more you benefit — beyond just your wages.',
    canonical: `${BASE_URL}/rewards`,
    og: {
      title: 'Rewards & Deals for Jobseekers in Singapore | EL Connect',
      description: 'Earn ElCoins, unlock exclusive rewards, and join Lucky Draw promotions. The more you work, the more you benefit.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/terms-of-service': {
    title: 'Terms of Service | EL Connect User Agreement',
    description: 'Read EL Connect\'s Terms of Service governing use of our job platform, app, and services in Singapore.',
    canonical: `${BASE_URL}/terms-of-service`,
    og: {
      title: 'Terms of Service | EL Connect User Agreement',
      description: 'Read EL Connect\'s Terms of Service governing use of our job platform, app, and services.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/privacy-policy': {
    title: 'Privacy Policy — How We Protect Your Data | EL Connect',
    description: 'Learn how EL Connect collects, uses, and protects your personal data in compliance with Singapore\'s PDPA. Your privacy is our priority.',
    canonical: `${BASE_URL}/privacy-policy`,
    og: {
      title: 'Privacy Policy | EL Connect',
      description: 'Learn how EL Connect collects, uses, and protects your personal data in compliance with Singapore\'s PDPA.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/singapore-jobs': {
    title: 'Singapore #1 Part Time Jobs Platform | EL Connect',
    description: 'Browse part time, temporary and on demand jobs in Singapore. F&B, retail & logistics — immediate hiring on EL Connect. Full time and short gigs available.',
    canonical: `${BASE_URL}/singapore-jobs`,
    og: {
      title: 'Singapore #1 Part Time Jobs Platform | EL Connect',
      description: 'Browse part time, temporary and on demand jobs in Singapore. F&B, retail & logistics — immediate hiring on EL Connect. Full time and short gigs available.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/gig-missions': {
    title: 'Your Next Gig Missions Starts Here | EL Connect',
    description: 'Browse Gig Missions in Singapore — delivery, creative & more. Short-term tasks with flexible hours. Your gig missions starts here. Apply instantly on EL Connect.',
    canonical: `${BASE_URL}/gig-missions`,
    og: {
      title: 'Your Next Gig Missions Starts Here | EL Connect',
      description: 'Browse Gig Missions in Singapore — delivery, creative & more. Short-term tasks with flexible hours. Fast and reliable. Apply instantly on EL Connect.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/singapore-part-time-jobs': {
    title: 'Browse & Apply Part Time Jobs in Singapore | EL Connect',
    description: 'Browse part time jobs in Singapore — Flexible and high paying temporary, on demand jobs. F&B, retail & more. Immediate hiring.  Apply on the EL Connect app.',
    canonical: `${BASE_URL}/singapore-part-time-jobs`,
    og: {
      title: 'Browse & Apply Part Time Jobs in Singapore | EL Connect',
      description: 'Browse part time jobs in Singapore — Flexible and high paying temporary, on demand jobs. F&B, retail & more. Immediate hiring.  Apply on the EL Connect app.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/singapore-full-time-jobs': {
    title: 'Full-Time Jobs in Singapore — Apply & Get Hired | EL Connect',
    description: 'Browse full-time job openings in Singapore across many roles & industries like sales, tech & admin. Connect with verified employers and apply instantly on EL Connect.',
    canonical: `${BASE_URL}/singapore-full-time-jobs`,
    og: {
      title: 'Full-Time Jobs in Singapore — Apply & Get Hired | EL Connect',
      description: 'Browse full-time job openings in Singapore across many roles & industries like sales, tech & admin. Connect with verified employers and apply instantly on EL Connect.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/singapore-gig-missions': {
    title: 'Gig Mission Singapore — Quick & Short Term Jobs | EL Connect',
    description: 'Browse all gig missions in Singapore — Match and Connect with right opportunities. Short-term, on demand tasks with flexible hours. Apply instantly on EL Connect.',
    canonical: `${BASE_URL}/singapore-gig-missions`,
    og: {
      title: 'Gig Mission Singapore — Quick & Short Term Jobs | EL Connect',
      description: 'Browse all gig missions in Singapore — Match and Connect with right opportunities. Short-term, on demand tasks with flexible hours. Apply instantly on EL Connect.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/login-jobseeker': {
    title: 'Jobseeker Login for Endless Job Opportunities | EL Connect',
    description: 'Log in to your EL Connect jobseeker account to browse part time jobs, track applications, and manage your shifts in Singapore. Unlock Endless opportunities.',
    canonical: `${BASE_URL}/login-jobseeker`,
    og: {
      title: 'Jobseeker Login for Endless Job Opportunities | EL Connect',
      description: 'Log in to your EL Connect jobseeker account to browse part time jobs, track applications, and manage your shifts in Singapore. Unlock Endless opportunities.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/login-employer': {
    title: 'Employer Login to Manage Job Postings | EL Connect',
    description: 'Log in to your EL Connect employer account to post jobs, manage applications, and hire part time workers across Singapore. Get job insights and reports.',
    canonical: `${BASE_URL}/login-employer`,
    og: {
      title: 'Employer Login to Manage Job Postings | EL Connect',
      description: 'Log in to your EL Connect employer account to post jobs, manage applications, and hire part time workers across Singapore. Get job insights and reports.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/signup-jobseeker': {
    title: 'Sign Up as Jobseeker — Find Part Time Jobs | EL Connect',
    description: 'Create your free EL Connect account and start finding part time, temporary, and on demand jobs across Singapore. Quick Singpass Sign up. Elevate your job hunt.',
    canonical: `${BASE_URL}/signup-jobseeker`,
    og: {
      title: 'Sign Up as Jobseeker — Find Part Time Jobs | EL Connect',
      description: 'Create your free EL Connect account and start finding part time, temporary, and on demand jobs across Singapore. Quick Singpass Sign up. Elevate your job hunt.',
      image: DEFAULT_OG_IMAGE,
    },
  },

  '/signup-employer': {
    title: 'Sign Up as Employer — Hire Staff in Singapore | EL Connect',
    description: 'Create your free EL Connect employer account and start hiring verified part time and temporary staff in Singapore by posting jobs.',
    canonical: `${BASE_URL}/signup-employer`,
    og: {
      title: 'Sign Up as Employer — Hire Staff in Singapore | EL Connect',
      description: 'Create your free EL Connect employer account and start hiring verified part time and temporary staff in Singapore by posting jobs.',
      image: DEFAULT_OG_IMAGE,
    },
  },

    '/resume-builder': {
    title: 'Revolutionize Job Search with AI Resume Builder | EL Connect',
    description: 'Our AI Resume Builder helps you craft compelling resumes tailored to your skills and experience.',
    canonical: `${BASE_URL}/resume-builder`,
    og: {
      title: 'Revolutionize Job Search with AI Resume Builder | EL Connect',
      description: 'Our AI Resume Builder helps you craft compelling resumes tailored to your skills and experience.',
      image: DEFAULT_OG_IMAGE,
    },
  },
};

/**
 * Returns a vue-meta `metaInfo` object for the given route path.
 * Usage inside a component:
 *
 *   import { getMetaInfo } from '@/seo.config';
 *   export default {
 *     metaInfo() { return getMetaInfo('/about-us'); },
 *     ...
 *   }
 */
export function getMetaInfo(routePath) {
  const s = SEO[routePath];
  if (!s) return {};
  return {
    title: s.title,
    meta: [
      { name: 'description', content: s.description },
      { property: 'og:title', content: s.og.title },
      { property: 'og:description', content: s.og.description },
      { property: 'og:image', content: s.og.image },
      { property: 'og:url', content: s.canonical, vmid: 'og:url' },
      { property: 'og:type', content: 'website' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: s.og.title },
      { name: 'twitter:description', content: s.og.description },
    ],
    // vmid must match the global mixin in main.js so vue-meta emits ONE canonical (component overrides mixin)
    link: [
      { rel: 'canonical', href: s.canonical, vmid: 'canonical' },
    ],
  };
}

export default SEO;
